module.exports = __webpack_public_path__ + "static/img/back_icon_5.d8654c8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/back_icon_5.png
// module id = qash
// module chunks = 1